import { employeeServices } from '@/services'
import { AttachmentUploader } from '@/shared/components/attachment-uploader'
import { Pill } from '@/shared/components/pill'
import { useGetEmployeeContractAttachmentQuery, useUpdateEmployeeContractAttachmentMutation } from '@/store/services/employee-contract-attachment.service'
import {
  Button,
  Dialog,
  DialogBody,
  DialogHeader
} from '@material-tailwind/react'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, generatePath, useLoaderData, useNavigate, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export const PendingEmployeeContractAttachmentUpload = () => {
  const { t } = useTranslation()
  const [currentResource, setCurrentResource] = useState({})
  const navigate = useNavigate()
  const { id } = useParams()
  console.log(id)
  const { data: currentAttachment } = useGetEmployeeContractAttachmentQuery(id)
  const currentUrlParams = useLocation().search

  const [updateEmployeeContractAttachment, { isLoading, isSuccess }] =
    useUpdateEmployeeContractAttachmentMutation()

  const onUpload = async (values) => {
    if (!values.document.filename) {
      toast.warn('Adjunta un documento antes de actualizar.')
      return
    }

    updateEmployeeContractAttachment(values)
  }

  const attachmentTypeOptions = useMemo(() => {
    return [currentAttachment.attachmentType]
  }, [currentAttachment])

  const initialValues = useMemo(() => {
    return {
      id: currentAttachment.id,
      attachment_type_id: currentAttachment.attachmentType.id,
      document: {},
      expiration_date: currentAttachment.expirationDate,
      period_month: currentAttachment.periodMonth,
      period_year: currentAttachment.periodYear,
      status: 'pending'
    }
  }, [currentAttachment])

  const resourcePromise = () => {
    return employeeServices.show({
      id: currentAttachment.employeeContract.employeeId
    })
  }

  useEffect(() => {
    if (!isSuccess) return

    navigate(`/attachments${currentUrlParams}`)
  }, [isSuccess])

  useEffect(() => {
    if (!currentAttachment.id) return

    const fetchResource = async () => {
      const { data } = await resourcePromise()
      const [resource = {}] = Object.values(data)
      setCurrentResource(resource)
    }

    fetchResource()
  }, [currentAttachment])

  const pillOptions = useMemo(() => {
    if (!currentResource.id) return []

    return [
      { label: t('common.firstName'), value: `${currentResource.name} ${currentResource.lastName}` },
      { label: t('documentNumber.one'), value: currentResource.documentNumber },
      { label: t('contract.one'), value: `${currentAttachment?.employeeContract?.contract?.id} - ${currentAttachment?.employeeContract?.contract?.name} `},
      { label: t('contractor.one'), value: `${currentAttachment?.employeeContract?.contract?.company?.name}`}
    ]
  }, [currentResource])

  return (
    <Dialog open size='lg'>
      <DialogHeader>Carga de documentos</DialogHeader>

      <DialogBody className='flex gap-4'>
        {pillOptions.map((pillOption) => (
          <Pill key={pillOption.label} {...pillOption} />
        ))}
      </DialogBody>

      <DialogBody>
        {attachmentTypeOptions.length && Object.keys(initialValues).length && (
          <AttachmentUploader
            attachmentTypes={attachmentTypeOptions}
            initialValues={initialValues}
            showDefaultHeader={false}
            onUpload={onUpload}
            isDisabled
          >
            {(handleSubmit) => (
              <div className='flex justify-between'>
                <Link to={generatePath(`/attachments${currentUrlParams}`)}>
                  <Button
                    variant='text'
                  >
                    Cancelar
                  </Button>
                </Link>
                <Button loading={isLoading} onClick={handleSubmit}>
                  Cargar archivo
                </Button>
              </div>
            )}
          </AttachmentUploader>
        )}
      </DialogBody>
    </Dialog>
  )
}
